<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="large-dialog"
    :close-on-click-modal="false"
    v-dialogDrag
  >
    <split-line content-position="left">基本信息</split-line>
    <div>
      <el-form :model="metadataForm" label-position="right" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="元数据名称">
              <el-input v-model="metadataForm.metaDataName" size="small" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="元数据代码">
              <el-input v-model="metadataForm.metaDataCode" size="small" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="来源数据库名称">
              <el-input v-model="metadataForm.dataSourceBase" size="small" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数据类型">
              <el-input v-model="metadataForm.dataType" size="small" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="来源数据表名称">
              <el-input v-model="metadataForm.tableName" size="small" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="长度">
              <el-input v-model="metadataForm.dataLong" size="small" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="精度">
              <el-input v-model="metadataForm.dataPrecision" size="small" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位">
              <el-input v-model="metadataForm.unitName" size="small" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="默认值">
              <el-input v-model="metadataForm.dataDefault" size="small" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="主键属性">
              <el-checkbox
                v-model="metadataForm.dataKey"
                :true-label="1"
                :false-label="0"
                :disabled="true"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="是否为空">
              <el-checkbox
                v-model="metadataForm.dataIsNotNull"
                :true-label="0"
                :false-label="1"
                :disabled="true"
              ></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <split-line content-position="left">全链分析</split-line>
    <div class="diagram w-full">
      <manhattanGraph
        :nodes="graphData.nodes"
        :edges="graphData.edges"
        v-if="isShowGraph"
      ></manhattanGraph>
    </div>
  </el-dialog>
</template>

<script>
import MetadataListService from '@/services/metadataListService'
import manhattanGraph from '../../../components/manhattanGraph'

export default {
  name: 'viewMetadata',
  components: {
    manhattanGraph,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dialogTitle: {
      type: String,
      default: '查看',
    }, // 弹窗标题
    operateMetadata: {
      type: Object,
      default: () => {
        return {}
      },
    }, // 操作项数据(查看)
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      metadataForm: {
        metaDataName: '', // 元数据名称
        metaDataCode: '', // 元数据代码
        dataType: '', // 数据类型
        dataSourceBase: '', // 数据库名称
        dataLong: '', // 长度
        tableName: '', // 来源数据表名称
        dataPrecision: '', // 精度
        unit: '', // 单位
        dataDefault: '', // 默认值
        dataKey: null, // 主键属性
        dataIsNotNull: null, // 是否不为空
      }, // 表单数据
      graphData: {
        nodes: [],
        edges: [],
      }, // grapg图数据
      isShowGraph: false, // 保证先拿到grapg图数据
    }
  },
  methods: {
    /**
     * @description 获取链式图数据
     */
    async getGraphDataList() {
      const res = await MetadataListService.getGraphData({
        id: this.metadataForm.id,
      })
      if (res && res.data && res.code === 0) {
        this.setIconPosition([...res.data])
      }
    },

    /**
     * @description 设置链式图图标位置以及边的关系和样式
     * @param {Array} graphList 二维数组
     */
    setIconPosition(graphList) {
      const nodes = [] // 节点数据
      const edges = [] // 边数据
      const copyGraphArr = _.cloneDeep(graphList)
      const copyGraphList = _.filter(copyGraphArr, (item) => {
        return item.length !== 0
      }) // 清除空数据
      copyGraphList.reverse() // 数据顺序颠倒(从最后一列到第一列)
      let lastList = [] // 上一列节点数据

      let nextPostionList = [] // 下一列节点位置数据
      let nodeDistanceObj = {} // 不同节点之间间距位置信息
      _.forEach(copyGraphList, (graphList, index) => {
        nodes[index] = []
        nextPostionList = []
        nodeDistanceObj = {}

        // 找到每一列label最长的元素，定下这一列节点的统一宽度
        const copyItemList = [...graphList]
        copyItemList.sort((a, b) => {
          return a.source.length - b.source.length
        })
        const maxLength = copyItemList[copyItemList.length - 1].source.length // 每一列label最长字符串长度

        /**
         * 将下一列两个节点之间需要添加的间隔记录下来(当前列不同source边之间需要存在的间隔距离)
         * 思路：
         *  找到下一列的节点，根据他们target对应当前列不同的节点来区分，记录他们的起始索引和结束索引以及对应几条边
         */
        if (index + 1 < copyGraphList.length) {
          let currentSource = copyGraphList[index + 1][0].source
          let currentNo = 0
          let lastItem = copyGraphList[index + 1][0]
          let lastEndIndex = -1

          _.forEach(copyGraphList[index + 1], (item, itemIndex) => {
            if (item.source !== currentSource) {
              nextPostionList[currentNo] = {
                source: currentSource,
                target: lastItem.target,
                firstTarget: '',
                startIndex: lastEndIndex + 1, // 该列节点数据起始索引
                endIndex: itemIndex - 1, // 该列节点数据结束索引
                length: lastItem.target ? itemIndex - lastEndIndex - 1 : 0, // 上一个节点对应几条边
              }
              currentNo += 1
              currentSource = item.source
              lastEndIndex = itemIndex - 1
              lastItem = item
            }
            if (itemIndex === copyGraphList[index + 1].length - 1) {
              nextPostionList[currentNo] = {
                source: currentSource,
                target: lastItem.target,
                startIndex: lastEndIndex + 1,
                endIndex: itemIndex,
                length: lastItem.target ? itemIndex - lastEndIndex - 1 : 0, // 上一个节点对应几条边
              }
            }
          })

          // 根据nextPostionList中的数据索引计算需要间隔的距离
          // source属性是对应的边
          let startNo = nextPostionList[0].endIndex
          let startSource = nextPostionList[0].source
          _.forEach(nextPostionList, (positionItem) => {
            if (positionItem.length && startSource !== positionItem.source) {
              nodeDistanceObj[positionItem.source] = (positionItem.startIndex - startNo - 2) * 50
              startNo = positionItem.endIndex
              startSource = positionItem.source
            }
          })
        }

        if (index === 0) {
          // 固定第一列的位置
          let moveDistance = 0 // 每个元素需要移动的距离
          _.forEach(graphList, (graphItem, itemIndex) => {
            if (nodeDistanceObj[graphItem.source]) {
              moveDistance += nodeDistanceObj[graphItem.source]
            }
            nodes[index].push({
              id: graphItem.source, // String，可选，节点的唯一标识
              x: 400 + index * 300, // Number，必选，节点位置的x值
              y: 0 + itemIndex * 50 + moveDistance, // Number，必选，节点位置的y值
              width: maxLength * 10 < 180 ? 180 : maxLength * 10, // Number，可选，节点大小的width值
              height: 40, // Number，可选，节点大小的height值
              attrs: {
                body: {
                  stroke: '#000', // 边框颜色
                  rx: 7, // 横向圆角
                  ry: 7, // 总项圆角
                }, // 外层body
                label: {
                  text: graphItem.source,
                  padding: 10,
                }, // 内层文字
              },
            })
            lastList.push({
              source: graphItem.source,
              sourcePosition: {
                x: 400 + index * 300, // Number，必选，节点位置的x值
                y: 0 + itemIndex * 50 + moveDistance, // Number，必选，节点位置的y值
              },
            }) // 收集当前列数据，给下一列使用
          })
        } else {
          if (!lastList.length) return
          const sameSourceNameObj = {} // 相同source为一个数组
          let currentSourceName = lastList[0].source
          sameSourceNameObj[currentSourceName] = []
          // 将上一列中同一个节点对应的边存储在一个数组内
          _.forEach(lastList, (item) => {
            if (item.source !== currentSourceName) {
              currentSourceName = item.source
              sameSourceNameObj[currentSourceName] = []
            }
            sameSourceNameObj[currentSourceName].push({
              ...item,
            })
          })
          // 先对数据进行判断，是否是存在多个节点对应一个节点
          const sameTargetObj = {}
          _.forEach(graphList, (graphItem) => {
            if (!sameTargetObj[graphItem.target]) {
              sameTargetObj[graphItem.target] = []
            }
            sameTargetObj[graphItem.target].push(graphItem.source)
          })

          const hasTargetList = [] // 有target的节点
          const hasTargetIndexList = [] // 有target的节点的index
          const sourceObj = {} // 以source为属性，保存这个source对应的所有边数据
          // 根据上一列节点数据，拿到当前列每个节点所有的数据(当前列的target对应sameSourceNameObj的属性)
          _.forEach(graphList, (graphItem) => {
            if (!sourceObj[graphItem.source]) {
              sourceObj[graphItem.source] = []
            }
            const currentSourceList = sameSourceNameObj[graphItem.target]
            if (currentSourceList && currentSourceList.length) {
              sourceObj[graphItem.source].push(...currentSourceList) // 可能一个节点会对应多条边
            }
          })
          // 去除掉空数据
          _.forEach(Object.keys(sourceObj), (key) => {
            if (sourceObj[key].length === 0) {
              Reflect.deleteProperty(sourceObj, key)
            }
          })

          let currentTarget = '' // 当前节点target名称
          _.forEach(graphList, (graphItem, graphIndex) => {
            // 同一个source(同一个节点)边数据只新建一个节点
            if (currentTarget !== graphItem.source) {
              currentTarget = graphItem.source
              let currentTargetObj = null
              if (currentTarget) {
                // 拿到有target属性(有连接节点的节点)节点对应的位置
                const currentSourceList = sourceObj[graphItem.source]
                if (sameTargetObj[graphItem.target].length > 1) {
                  // 多个对应一个
                  if (currentSourceList && currentSourceList.length) {
                    const sourceLength = sameTargetObj[graphItem.target].length
                    const currentSourceIndex = sameTargetObj[graphItem.target].indexOf(
                      currentTarget
                    )
                    currentTargetObj = {
                      currentNo: graphIndex,
                      x: currentSourceList[0].sourcePosition.x - 300,
                      y:
                        currentSourceList[0].sourcePosition.y +
                        (currentSourceIndex - parseInt(sourceLength / 2)) * 50,
                    }
                    hasTargetList.push(currentTargetObj)
                    hasTargetIndexList.push(graphIndex)
                  }
                } else {
                  // 一个对应多个或一个
                  if (currentSourceList && currentSourceList.length) {
                    const listLength = currentSourceList.length
                    if (listLength % 2 === 1) {
                      currentTargetObj = {
                        currentNo: graphIndex,
                        x: currentSourceList[parseInt(listLength / 2)].sourcePosition.x - 300,
                        y: currentSourceList[parseInt(listLength / 2)].sourcePosition.y,
                      }
                    } else {
                      currentTargetObj = {
                        currentNo: graphIndex,
                        x: currentSourceList[parseInt(listLength / 2)].sourcePosition.x - 300,
                        y:
                          (currentSourceList[parseInt(listLength / 2)].sourcePosition.y +
                            currentSourceList[parseInt(listLength / 2) - 1].sourcePosition.y) /
                          2,
                      }
                    }
                    hasTargetList.push(currentTargetObj)
                    hasTargetIndexList.push(graphIndex)
                  }
                }
              }
            }
          })
          let currentNodeSource = '' // 当前节点的source
          lastList = []
          // 对多个节点指向同一个节点且位置重合的元素位置进行调整
          const positionedList = [...hasTargetList] // 已定位的元素

          _.forEach(graphList, (item, itemIndex) => {
            if (currentNodeSource !== item.source) {
              currentNodeSource = item.source
              let posX = null // x坐标
              let posY = null // y坐标
              if (hasTargetIndexList.includes(itemIndex)) {
                _.forEach(positionedList, (listItem) => {
                  if (listItem.currentNo === itemIndex) {
                    posX = listItem.x
                    posY = listItem.y
                  }
                })
              } else {
                // 找到距离自身最近已定位的元素
                let absDistance = 100000 // 差距绝对值
                let distance = 100000 // 实际差距
                let nearestNode = null // 距离最近的元素
                _.forEach(positionedList, (item) => {
                  if (Math.abs(itemIndex - item.currentNo) < absDistance) {
                    distance = itemIndex - item.currentNo
                    absDistance = Math.abs(itemIndex - item.currentNo)
                    nearestNode = item
                  }
                })
                // 根据已定位的元素定位自身位置
                if (nearestNode) {
                  posX = nearestNode.x
                  posY = distance > 0 ? 50 + nearestNode.y : -50 + nearestNode.y
                  positionedList.push({
                    currentNo: itemIndex,
                    x: posX,
                    y: posY,
                  })
                }
              }

              if (posX !== null && posY !== null) {
                nodes[index].push({
                  id: item.source, // String，可选，节点的唯一标识
                  x: posX, // Number，必选，节点位置的x值
                  y: posY, // Number，必选，节点位置的y值
                  width: maxLength * 10 < 180 ? 180 : maxLength * 10, // Number，可选，节点大小的width值
                  height: 40, // Number，可选，节点大小的height值
                  attrs: {
                    body: {
                      stroke: '#000', // 边框颜色
                      rx: 7, // 横向圆角
                      ry: 7, // 总项圆角
                    }, // 外层body
                    label: {
                      text: item.source,
                      padding: 10,
                    }, // 内层文字
                  },
                })
              }
              lastList.push({
                source: item.source,
                sourcePosition: {
                  x: posX, // Number，必选，节点位置的x值
                  y: posY, // Number，必选，节点位置的y值
                },
              }) // 收集当前列数据，给下一列使用
            }

            if (item.target) {
              edges.push({
                router: {
                  name: 'manhattan', // 该路由由水平或垂直的正交线段组成，并自动避开路径上的其他节点
                },
                ...item,
              })
            }
          })
        }
      })
      this.graphData = {
        nodes,
        edges,
      }
      this.isShowGraph = true
    },
  },
  created() {
    this.metadataForm = { ...this.operateMetadata }
    this.getGraphDataList()
  },
}
</script>

<style lang="scss" scoped>

/deep/ .el-form-item__label {
  text-align: right;
}
.diagram {
  height: 300px;
}

</style>
